<template>
	<div class="insideBody">
		<div class="studyReport">
			
			<div class="main"  id="capture">
				
				<div class="conTop clr" >
					<div class="sctx fl clr">
						<img class="img fl" :src="$store.state.index.avatar" />
						<div class="tit" >{{userinfo.username}}</div>
					</div>
					<div class="text clr" >
						<img class="imgs fl" src="../../assets/images/top2.png" />
						<div class="con clr">
							<div class="tits fl">{{userinfo.duanweistr}}</div>
							<div class="smt fl">
								<div class="names">距升级还差 {{userinfo.jifencz}} 积分</div>
								<div class="progress">
									<el-progress color="#0cb1a6" :show-text="false" :percentage="userinfo.jindubi*100"></el-progress>
								</div>
								<div class="name">
									<span>积分：{{userinfo.jifen}} </span>
									<span>全国排名：{{userinfo.paiming}} 名</span>
								</div>
							</div>
							<div class="tits fl">白银</div>
							<div class="export fr" @click="getImg">导出学习报告</div>
						</div>
					</div>
				</div>
				<div>
          <div class="data_top">
            <ul>
              <li class="li1">
                <div class="tit">总学习时长</div>
                <div class="text"><span>{{alltime}}</span>分钟</div>
              </li>
              <li class="li2">
                <div class="tit">登录次数</div>
                <div class="text"><span>{{logincount}}</span>次</div>
              </li>
              <li class="li3">
                <div class="tit">总获得积分</div>
                <div class="text"><span>{{jifen}}</span>积分</div>
              </li>
            </ul>
          </div>
          
          <div class="data_list">
            <div class="tits">
              学习时间柱状图
              <div class="name_list name_list1 fr">学习时长</div>
              <!-- <div class="name_list name_list2 fr">有效时长</div> -->
            </div>
            <div id="Chart" class="Chart"></div>
          </div>
				</div>
			</div>
			
			<div class="details hide"> <!-- 详情 -->
				<div class="data_list">
					<div class="tits">
						积分详情
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="150"
								label="时间">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="80"
								label="版块">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="120"
								label="教材版本">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="60"
								label="单元">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="100"
								label="学习时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date6"
								min-width="80"
								label="积分">
								<template slot-scope="scope">
									<span class="red">{{scope.row.date6}}</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
				<div class="data_list">
					<div class="tits">
						登录记录
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData2"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="150"
								label="时间">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="80"
								label="操作系统">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="80"
								label="浏览器">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="80"
								label="分辨率">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="200"
								label="IP地址">
							</el-table-column>
							
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
			</div>
		 
		</div>
	</div>
</template>
<script>
import domtoimage from 'dom-to-image';
import { getzk } from "../../api/report";
export default {
  data(){
    return {
      userinfo: this.utils.storageGet("userinfo"),
      alltime:0,
      logincount:0,
      jifen:0,
      xz:[],
      yz:[],
			tableData: [{
				date1: '2020-06-24 14：30',
				date2: '同步课文',
				date3: '人教版 七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '+6'
			}, {
				date1: '2020-06-24 14：30',
				date2: '同步课文',
				date3: '人教版 七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '+6'
			}],
			tableData2: [{
				date1: '2020-06-24 14：30',
				date2: 'Windows',
				date3: '谷歌',
				date4: '1920*1080',
				date5: '  114.100.65.144 合肥市',
			}, {
				date1: '2020-06-24 14：30',
				date2: 'Windows',
				date3: '谷歌',
				date4: '1920*1080',
				date5: '  114.100.65.144 合肥市',
      }] ,
     
		};
	},
	created(){
	},
	methods:{
    getzongkuo(){
      let that = this;
      getzk({userid:that.userinfo.userid}).then(res=>{
         
        that.alltime = res.result.allmiunte;
        that.logincount = res.result.logcount;
        that.jifen = res.result.jifen;
        that.xz = res.result.xz;
        that.yz = res.result.yz;
        setTimeout(()=>{
          that.Chart();
        },500);
      });
    },
    getImg() {

      let node = document.getElementById('capture');
      domtoimage.bgcolor = '#ffffff';
     
      domtoimage.toPng(node).then(
        (dataUrl) => {
          let userinfo = this.utils.storageGet("userinfo");
       
          let link = document.createElement("a");
          link.href = dataUrl;//下载链接
          link.setAttribute("download",`${userinfo.username} - 学习总括.png`);
          link.style.display = "none";//a标签隐藏
          document.body.appendChild(link);
          link.click();
        }        
      ).catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

     
    },
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				legend: { 
					left:'right',
					top: 0,
					data:[]//['学习时长','有效时长']
				},
				grid: {
					left: 10,
					right: 40,
					bottom: 0,
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						name: '日期',
						data: that.xz
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '时间/分钟',
					}
				],
				series: [
					{
						name:'学习时长',
						type:'bar',
						stack: '日期',
						color: "#4069fa",
						data: that.yz
					},
					// {
					// 	name:'有效时长',
					// 	type:'bar',
					// 	stack: '日期',
					// 	color: "#cccccc",
					// 	data: [50,20,30,25,50,25,60,40,20,30,25,40]
					// },
				]
			});
		}
	},
	mounted(){
		var that = this;
		that.getzongkuo();
	}
}
</script>
<style scoped>
	.main{
    background: #fff;
  }
</style>